import React from 'react';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    '& > * + *': {
      marginLeft: theme.spacing(2),
    },
  },
  colorPrimary: {
    color: '#FFCC00 !important',
  },
}));

export default function Spinner() {
  const classes = useStyles();

  return (
    <Grid container direction="row" justify="center" alignItems="center">
      <Grid item>
        <div className={classes.root}>
          <CircularProgress disableShrink className={classes.colorPrimary}/>
        </div>
      </Grid>
    </Grid>
  );
}
